import React from 'react';
import TextField from '@material-ui/core/TextField';
import { Button } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { DevAlert } from '../index';
import '../../styles/components/volunteers/searcher.scss';

export default function Searcher() {
  const [devAlert, setDevAlert] = React.useState(false);

  return (
    <form className="searcher" noValidate autoComplete="off">
      <TextField
        className="searcher__query"
        id="outlined-basic"
        label="Поисковый запрос"
        variant="outlined"
      />
      <Button
        variant="contained"
        color="primary"
        size="large"
        startIcon={<SearchIcon />}
        onClick={() => setDevAlert(true)}
      >
        Найти
      </Button>
      <DevAlert isOpen={devAlert} callBack={() => setDevAlert(false)} />
    </form>
  );
}
